import React from 'react';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';

import { Button } from '@smartplatform/ui';
import StageEdit from './StageEdit';
import AddStage from './AddStage';

@inject('store') @observer
export default class Question extends React.Component {

	@observable stages = [];
	@observable addingProtocol = false;
	
	constructor(props) {
		super(props);
		this.store = props.store;
		// if (props.question.order === 1) this.addingProtocol = true;
		this.init();
	}
	
	init = async () => {
		this.stages = await this.props.question.stages.find({
			include: ['type'],
			order: 'id asc',
		});
		// console.log('>>>', this.props.question.id, this.stages.length);
	};
	
	addProtocol = () => this.addingProtocol = true;
	
	cancel = () => this.addingProtocol = false;
	
	update = () => {
		this.addingProtocol = false;
		this.init();
	};
	
	render() {
		const { question } = this.props;
		
		return <div className="question block">
			<div className="name">
				{question.order && <span className="number">Вопрос №{question.order}.</span>}
				{question.name}
				<div className="info">
					id: {question.id}, epz: {question.questionId}
				</div>
			</div>
			<div className="stages">
				{this.stages.map(stage => <StageEdit key={stage.id} stage={stage} onDelete={this.init}/>)}
			</div>
			{this.store.protocols.length > 0 ?
				<div className="actions">
					{!this.addingProtocol ?
						<Button className="btn-sm btn-info" onClick={this.addProtocol}>Добавить протокол</Button>
						:
						<AddStage question={question} onUpdate={this.update} onCancel={this.cancel} />
					}
				</div>
				:
				null
			}
		</div>;
	}
}

